/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * How an answer is given. Belongs to the question, not to a version: changing it would make historical results incomparable, so a different type means a different question.
 * @export
 * @enum {string}
 */

export const QuestionTypeDto = {
    SingleChoice: 'SINGLE_CHOICE',
    MultipleChoice: 'MULTIPLE_CHOICE',
    PassFail: 'PASS_FAIL',
    OpenText: 'OPEN_TEXT',
    Practical: 'PRACTICAL',
    Ordering: 'ORDERING',
    ExpectedAnswer: 'EXPECTED_ANSWER'
} as const;

export type QuestionTypeDto = typeof QuestionTypeDto[keyof typeof QuestionTypeDto];



